<template>
 <v-dialog v-model="mainDialog"  persistent>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                             class="ma-2" color="primary" small
                            v-bind="attrs"
                            v-on="on"
                            > <v-icon>mdi-plus</v-icon> เพิ่มวัสดุสิ้นเปลือง</v-btn>
                        </template>
    <v-card tile>
        <v-card-title>เพิ่มข้อมูลวัสดุสิ้นเปลืองเข้าระบบ</v-card-title>
        <v-divider></v-divider>
        <v-container>
            <v-form ref="form" v-model="valid" lazy-validation>
            <v-row>
                <v-col cols="2"><DatePicker ref="docDate" @dateFormatted="setDocDate" label="วันที่ในเอกสาร"> </DatePicker></v-col>
                <v-col cols="2"><DatePicker ref="receiveDate" @dateFormatted="setReceiveDate" label="วันที่รับวัสดุ"> </DatePicker></v-col>
                <v-spacer></v-spacer>
                <v-col><v-text-field 
                    autofocus
                    :rules="[rules.required]" 
                    v-model="mainData.receiveNo" outlined placeholder=" "
                    label="เลขที่ใบรับวัสดุ"></v-text-field></v-col>
                <v-col><v-text-field :disabled="mainData.details.length > 0" 
                    v-model="mainData.percentDiscount" 
                    value="0" maxlength="3" :rules="[rules.requiredMaxNumber(100)]" outlined placeholder=" " label="ส่วนลด"></v-text-field></v-col>
                <v-col>
                    <v-select
                        outlined
                        placeholder=" "
                        label="สถานะใบรับวัสุดสิ้นเปลือง"
                        v-model="mainData.status"
                        :items="statusItems">
                    </v-select>
                </v-col>
            </v-row>
            <!--
            <v-row>
                <v-col><v-text-field 
                    autofocus
                    :rules="[rules.required]" 
                    v-model="mainData.receiveNo" outlined placeholder=" "
                    label="เลขที่ใบรับวัสดุ"></v-text-field></v-col>
                <v-col><v-text-field v-model="mainData.distributor" outlined placeholder=" " label="ผู้จำหน่าย"></v-text-field></v-col>
                <v-col><v-text-field v-model="mainData.percentDiscount" value="0" maxlength="3" v-mask="'###'"  outlined placeholder=" " label="ส่วนลด"></v-text-field></v-col>
            </v-row>
-->
            <v-row>
                <v-col>
                    <v-data-table
                    :headers="header"
                    :items="mainData.details"
                    style="border:0.2px solid; border-color:#909090"
                    >
                    <template v-slot:top>
                            <v-toolbar flat color="white">
                                <v-toolbar-title>ข้อมูลวัสดุสิ้นเปลือง</v-toolbar-title>
                            </v-toolbar>
                            <v-divider
                                class="mx-4"
                                inset
                                ></v-divider>
                            <v-form ref="formDetail" v-model="validDetail" lazy-validation>
                                <v-row class="mx-2">
                                    <v-col>
                                        <v-autocomplete
                                            autofocus
                                            v-model="selectedConsumable"
                                            outlined 
                                            placeholder="พิมพ์รหัส หรือ ชื่อวัสดุสิ้นเปลือง"
                                            :items="consumableList"
                                            return-object
                                            item-text="consumableDisplay"
                                            item-value="consumableCode"
                                            :rules="[rules.requiredConsumable]"
                                            label="วัสดุสิ้นเปลือง">
                                        </v-autocomplete>
                                    </v-col>
                                    <v-col cols="1"><v-text-field :rules="[rules.requiredNumberPositive]"  v-model="detail.qty" outlined placeholder=" " label="จำนวน" maxlength="6"></v-text-field></v-col>
                                    <v-col cols="2"><v-text-field :rules="[rules.requiredNumber]" v-model="detail.price" outlined placeholder=" " label="ราคา"></v-text-field></v-col>
                                    <v-col cols="2"><v-text-field :rules="[rules.requiredNumber]" v-model="detail.unitPrice" outlined placeholder=" " label="ราคาต่อหน่วย"></v-text-field></v-col>
                                    <v-col cols="1"><v-text-field disabled  v-model="detail.size" outlined placeholder=" " label="ปริมาณของหน่วยรับเข้า"></v-text-field></v-col>
                                    <v-col cols="2">
                                        <v-btn class="ma-2"  color="primary" @click="saveDetail">เพิ่ม</v-btn>
                                        <v-btn class="ma-2"  color="primary" @click="closeDialog"> ล้าง</v-btn>
                                    </v-col>
                                </v-row>
                            </v-form> 
                    </template>
                        <template v-slot:header.discount>
                            <thead>
                                <tr>
                                    <th colspan="2" class="indigo--text text-center">ส่วนลด</th>
                                </tr>
                                <tr>
                                    <th class="indigo--text text-center">%</th>
                                    <th class="indigo--text text-center">ยอด</th>
                                </tr>
                            </thead>
                        </template>

                        <template v-slot:item.discount="{item}">
                            <tr>
                                <th class="text-center">{{item.percentDiscount}}</th>
                                <th class="text-center">{{item.discount}}</th>
                            </tr>
                        </template>

                            <template v-slot:item.action="{ item }">
                            <v-icon
                                small
                                @click="deleteDetail(item)"
                            >
                                delete
                            </v-icon>
                        </template>
                    </v-data-table>
                </v-col>
            </v-row>

                <v-row>
                <v-col cols="6">
                    <v-data-table
                    :headers="headerSummary"
                    :items="itemSummary"
                    style="border:0.2px solid; border-color:#909090"
                    hide-default-footer
                    >
                    </v-data-table>
                </v-col>
                <v-spacer></v-spacer>
                <v-col class="d-flex align-end align-center">
                    <v-btn style="margin-right:10px;" color="primary" @click="save">บันทึก</v-btn>&nbsp;
                    <v-btn color="primary"  @click="closeMain">ยกเลิก</v-btn>
                </v-col>
            </v-row>
            </v-form>
            
        </v-container>
        
    </v-card>
 </v-dialog>
</template>


<style scoped>
    .col-header {
        background: indigo;
        color: indigo;
    }
</style>

<script>

import DatePicker from '@/components/Shared/DatePicker'
import {insertStockConsumable, updateStockConsumableReceive} from '@/api/stock/stock-consumable-api.js'
import {listDropdownConsumableType} from '@/api/common/dropdown-api.js'
import numeral from 'numeral'
import rules from '@/assets/js/rules.js'
import {parseDate} from '@/assets/js/common.js'

export default {
    name: 'AddStockConsumable',
    props: ["branchCode"],
    components: {
        DatePicker
    },
    watch: {
        selectedConsumable(val) {
            this.detail.size = val.size;
            this.detail.unitPrice = numeral(val.unitPrice).format('0.00');
            this.detail.price =  numeral(val.price).format('0.00');
            this.detail.priceDisplay = numeral(val.price).format('0,0.00');
        },
        mainDialog(val) {
            if (val) {
                this.listConsumableData();
                this.resetSummary();
            } else {
                this.isEditMode = false;
                this.$refs.docDate.resetDate();
                this.$refs.receiveDate.resetDate();
            }
        }
    },
    data: () => ({
        isEditMode: false,
        mainDialog: false,
        rules: rules,
        valid: false,
        validDetail: false,
        header: [
            {text: 'หมายเลขวัสดุ', value: 'consumableCode', class: 'indigo--text'},
            {text: 'ชื่อรายการวัสดุ', value: 'consumableName', class: 'indigo--text'},
            {text: 'จำนวน', value: 'qtyDisplay', class: 'indigo--text'},
            {text: 'ราคา', value: 'priceDisplay', class: 'indigo--text'},
            {text: 'ยอดรวม', value: 'amountDisplay', class: 'indigo--text'},
            {text: 'ปริมาณของหน่วยรับเข้า', value: 'size', class: 'indigo--text'},
            {text: 'ส่วนลด', value: 'discountDisplay', sortable: false, class: 'indigo--text'},
            {text: 'รวมสุทธิ', value: 'netAmountDisplay', class: 'indigo--text'},
            {text: 'Actions', value: 'action', sortable: false, class: 'indigo--text'}
        ],
        mainData: {
            stockConsumableId: -1,
            branchCode: '',
            receiveNo: '',
            docDate: '',
            receiveDate: '',
            distributor: '',
            stockOfficer: '',
            percentDiscount: 0,
            status: 'draft',
            details: []
        },
        defaultMainData: {
            branchCode: '',
            receiveNo: '',
            docDate: '',
            receiveDate: '',
            distributor: '',
            percentDiscount: 0,
            status: 'draft',
            details: []
        },
        detail: {
                consumableCode: '',
                consumableName: '',
                warehouse: '',
                price: '',
                qty: '',
                size: 0,
                amount: 0,
                netAmount: 0,
                percentDiscount: 0,
                discount: 0,
                remark: '',
        },
        defaultDetail: {
                consumableCode: '',
                consumableName: '',
                warehouse: '',
                price: '',
                qty: '',
                size: 0,
                amount: 0,
                netAmount: 0,
                percentDiscount: 0,
                discount: 0,
                remark: '',
        },
        headerSummary: [
            {text: '', value: 'sumType'},
            {text: 'ยอดรวม', value: 'amountDisplay'},
            {text: 'ส่วนลด', value: 'discountDisplay'},
            {text: 'ราคารวมสุทธิ', value: 'netDisplay'}
        ],
        itemSummary: [
        ],
        statusItems: ['draft', 'confirm'],
        consumableList: [],
        selectedConsumable: {},
        summryDefault: {
            amount: 0,
            discount: 0,
            net: 0,
            amountDisplay: 0,
            discountDisplay: 0,
            netDisplay: 0
        },
        summary: {
            sum: {
                sumType: 'รวม',
                amount: 0,
                discount: 0,
                net: 0,
                amountDisplay: 0,
                discountDisplay: 0,
                netDisplay: 0
            },
            vat: {
                sumType: 'ภาษี 7%',
                amount: 0,
                discount: 0,
                net: 0,
                amountDisplay: 0,
                discountDisplay: 0,
                netDisplay: 0
            },
            total: {
                sumType: 'รวมทั้งสิ้น',
                amount: 0,
                discount: 0,
                net: 0,
                amountDisplay: 0,
                discountDisplay: 0,
                netDisplay: 0
            }
        }
    }),
    methods: {
        setDocDate(val) {
            this.mainData.docDate = val;
        },
        setReceiveDate(val) {
            this.mainData.receiveDate = val;
        },
        deleteDetail(item) {
            if (!confirm("คุณต้องการลบข้อมูลใช่หรือไม่ ?")) {
                return;
            }
            let index = this.mainData.details.indexOf(item);
            this.mainData.details.splice(index, 1);
            this.removeSummary(item);
        },
        saveDetail() {
            if (!this.$refs.formDetail.validate()) {
                return;
            }
            this.setDetailData();
            this.addSummary();
            this.closeDialog();
        },
        setDetailData() {
            this.detail.consumableCode = this.selectedConsumable.consumableCode;
            this.detail.consumableName = this.selectedConsumable.consumableName;
            this.detail.qtyDisplay = numeral(this.detail.qty).format('0.00');
            this.detail.priceDisplay = numeral(this.detail.price).format('0.00');
            this.detail.amount = this.detail.qty * this.detail.price;
            this.detail.percentDiscount = this.mainData.percentDiscount;
            this.detail.discount = this.detail.percentDiscount == 0 ? 0 : (this.detail.amount * this.detail.percentDiscount) / 100;
            this.detail.netAmount = this.detail.amount - this.detail.discount;
            this.setDetailDisplay(this.detail);
            this.mainData.details.push(this.detail);
        },
        addSummary() {
            this.summary.sum.amount += this.detail.amount;
            this.summary.sum.discount += this.detail.discount;
            this.summary.sum.net += this.detail.netAmount;
            this.calculateSummary();
        },
        removeSummary(item) {
            this.summary.sum.amount -= item.amount;
            this.summary.sum.discount -= item.discount;
            this.summary.sum.net -= item.netAmount;
            this.calculateSummary();
        },
        setDetailDisplay(detail) {
            detail.amountDisplay = numeral(detail.amount).format('0,0.00');
            detail.discountDisplay = numeral(detail.discount).format('0,0.00');
            detail.netAmountDisplay = numeral(detail.netAmount).format('0,0.00');
        },
        resetSummary() {
            this.summary.sum.amount = 0;
            this.summary.sum.discount = 0;
            this.summary.sum.net = 0;

            this.summary.vat.amount = 0;
            this.summary.vat.discount = 0;
            this.summary.vat.net = 0;

            this.summary.total.amount = 0;
            this.summary.total.discount = 0;
            this.summary.total.net = 0;
            
            this.summary.sum = Object.assign(this.summary.sum, this.summaryDefault);
            this.summary.vat = Object.assign(this.summary.vat, this.summaryDefault);
            this.summary.total = Object.assign(this.summary.total, this.summaryDefault);
            this.setSummaryDisplay(this.summary.sum);
            this.setSummaryDisplay(this.summary.vat);
            this.setSummaryDisplay(this.summary.total);
        },
        calculateSummary() {
            
            this.summary.vat.amount = (this.summary.sum.amount * 7) / 100;
            this.summary.vat.discount = (this.summary.sum.discount * 7) / 100;
            this.summary.vat.net = (this.summary.sum.net * 7) / 100;

            this.summary.total.amount = this.summary.sum.amount + this.summary.vat.amount;
            this.summary.total.discount = this.summary.sum.discount + this.summary.vat.discount;
            this.summary.total.net = this.summary.sum.net + this.summary.vat.net;

            this.setSummaryDisplay(this.summary.sum);
            this.setSummaryDisplay(this.summary.vat);
            this.setSummaryDisplay(this.summary.total);
        },
        setSummaryDisplay(summary) {
            summary.amountDisplay = numeral(summary.amount).format('0,0.00');
            summary.discountDisplay = numeral(summary.discount).format('0,0.00');
            summary.netDisplay = numeral(summary.net).format('0,0.00');
        },
        closeDialog() {
            this.selectedConsumable = Object.assign({}, {});
            this.detail = Object.assign({}, this.defaultDetail);
        },
        closeMain() {
            this.mainData = Object.assign({}, this.defaultMainData);
            this.mainData.details =  Object.assign([], []);
            this.resetSummary();
            this.mainDialog = false;
        },
        save() {
            if (!this.$refs.form.validate()) {
                return;
            }
            this.mainData.branchCode = this.branchCode;
            this.mainData.totalAmount = this.summary.total.net;
            this.$loading(true);

            if (this.isEditMode) {
                updateStockConsumableReceive(this.mainData).then( () => {
                    this.$loading(false);
                    this.closeMain();
                    this.$emit('saved');
                }).catch( () => {
                    this.$loading(false);
                });
            } else {
                insertStockConsumable(this.mainData).then( () => {
                    this.$loading(false);
                    this.closeMain();
                    this.$emit('saved');
                }).catch( () => {
                    this.$loading(false);
                });
            }
            
        },
        listConsumableData() {
            listDropdownConsumableType('DOCSA', this.branchCode, false).then(rs => {
                this.consumableList = rs;
            });
        },
        show(summary, mainData) {
            this.mainDialog = true;
            this.isEditMode = true;
            this.$nextTick(() => {
                this.itemSummary = summary;
                this.summary.sum = summary[0];
                this.summary.vat = summary[1];
                this.summary.total = summary[2];
                this.mainData = mainData;
                if (this.mainData.details) {
                    this.mainData.details.forEach(e => {
                        e.qtyDisplay = numeral(e.qty).format('0,0.00');
                        e.priceDisplay = numeral(e.price).format('0,0.00');
                    });
                }
                this.$refs.docDate.setDate(parseDate(this.mainData.docDate));
                this.$refs.receiveDate.setDate(parseDate(this.mainData.receiveDate));
            });
            
        }
    },
    mounted() {
        if (this.branchCode == undefined) return;
        //this.listConsumableData();
        this.itemSummary.push(this.summary.sum);
        this.itemSummary.push(this.summary.vat);
        this.itemSummary.push(this.summary.total);
    }
}
</script>
